import React, { createContext, useContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
    const [subscription, setSubscription] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');

        const checkToken = () => {
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    console.log('Decoded Token in Provider:', decodedToken);
                    const userSubscription = decodedToken.subscription;

                    if (userSubscription) {
                        // Add subscription to localStorage and stop checking further
                        sessionStorage.setItem('userSubscription', userSubscription);
                        setSubscription(userSubscription);
                        return true; // Token is valid and subscription found
                    } else {
                        console.log('No subscription found in token');
                    }
                } catch (error) {
                    console.error('Error decoding token:', error);
                }
            } else {
                console.log('No token found in localStorage');
                setSubscription(null);  // Reset subscription if no token is found
            }
            return false; // Token is invalid or not found
        };

        // Initial check
        const isTokenValid = checkToken();

        if (!isTokenValid) {
            // Set up interval to check every 2 seconds only if token is not valid
            const intervalId = setInterval(() => {
                const valid = checkToken();
                if (valid) {
                    clearInterval(intervalId); // Clear interval if token is valid
                }
            }, 2000);

            // Clean up the interval on component unmount
            return () => clearInterval(intervalId);
        }

    }, []);

    return (
        <SubscriptionContext.Provider value={subscription}>
            {children}
        </SubscriptionContext.Provider>
    );
};

export const useSubscription = () => {
    return useContext(SubscriptionContext);
};
